// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import downloadReportQuery from '../../helpers/downloadReportQuery'
import generateSearchQuery from '../../helpers/generateSearchQuery'
import downloadCustomReportQuery from '../../helpers/downloadCustomReportQuery'
import {
  eChannelsPermission,
} from '../../helpers/permissions'

const { axiosIns } = useJwt

export default {
  getHostFIList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/HostFI/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createHostFIAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CREATE_HOST_FINANCIAL_INSTITUTION)
      const response = await axiosIns.post('/card/api/HostFI/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateHostFIAction: async (context, formData) => {
    try {
      //   useJwt.setPermission(accountPermissions.VIEW_ACCOUNT_OFFICER)
      useJwt.setPermission(eChannelsPermission.MODIFY_HOST_FINANCIAL_INSTITUTION)
      const response = await axiosIns.put('/card/api/HostFI/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCardProfileList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/CardProfile/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCardProfileAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CREATE_CARD_PROFILE)
      const response = await axiosIns.post('/card/api/CardProfile/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCardProfileAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.MODIFY_CARD_PROFILE)
      const response = await axiosIns.put('/card/api/CardProfile/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  updateStatus: async (context, { statusValues, routeName, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/card/api/${routeName}/v1/UpdateStatus`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  requestUnAssignedCardsAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.REQUEST_UNASSIGNED_CARDS)
      const response = await axiosIns.post('/card/api/CardGeneration/v1/RequestUnassignedCards', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  requestAssignedCardsAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.REQUEST_ASSIGNED_CARDS)
      const response = await axiosIns.post('/card/api/CardGeneration/v1/RequestAssignedCards', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAssignedCardsByAccountNumbers: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/card/api/CardGeneration/v1/ValidateAssignedCardAccounts', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getListBatchRequests: async (context, { requestType, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/card/api/CardGeneration/v1/GetBatchesForIssuance?RequestType=${requestType}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBatchRequestList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/CardGeneration/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  searchCustomerAccountToIssue: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/CardAccount/v1/GetDetailsOfAccountToIssue',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAvailableCardLists: async (context, {
    cardGenerationRequestId, issuanceStatus, status, permission,
  }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/card/api/Card/v1/Search?CardGenerationRequestId=${cardGenerationRequestId}&IssuanceStatus=${issuanceStatus}&Status=${status}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createUnAssignedCardsAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/card/api/CardAccount/v1/LinkAccount', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createAssignedCardsAction: async (context, { assignedFormData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/card/api/CardAccount/v1/IssueCard', assignedFormData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  unlinkCard: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/tpcard/api/ProvidusCards/v1/UnlinkCard', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCardAccountList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/CardAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCardRequestLogs: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/CardGeneration/v1/SearchCustomerCardRequest',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getManageCardList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/Card/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCardStatus: async (context, { statusValues, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/card/api/Card/v1/UpdateStatus', statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  takeCardDeliveryAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.RECEIVE_CARD_DELIVERY)
      const response = await axiosIns.put('/card/api/CardGeneration/v1/TakeStockDelivery', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  revokeCardAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.REVOKE_CARD_REQUEST)
      const response = await axiosIns.put('/card/api/CardGeneration/v1/Cancel', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  // Channel-Interbank Transfer
  getGatewayConfigurations: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/Client/v1/SearchTransferSettlementGl',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGatewayProviders: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/interbankpayment/api/Client/v1/GetConfiguredGateway')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getISWCredential: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/interbankpayment/api/Client/v1/GetISWCredential')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getNIPCredential: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/interbankpayment/api/Client/v1/GetNipEasyPayCredential')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  addISWCredential: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/interbankpayment/api/Client/v1/AddISWCredential', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  addNIPCredential: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/interbankpayment/api/Client/v1/AddNipCredential', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateISWCredential: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/interbankpayment/api/Client/v1/UpdateISWCredential', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateNIPCredential: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/interbankpayment/api/Client/v1/UpdateNipEasyPayCredential', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getNipEasyPayCredential: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/interbankpayment/api/Client/v1/GetNipEasyPayCredential')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  addNipCredential: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/interbankpayment/api/Client/v1/AddNipCredential', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateNipEasyPayCredential: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/interbankpayment/api/Client/v1/UpdateNipEasyPayCredential', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getEtzCredential: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/interbankpayment/api/Client/v1/GetEtzCredential')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  addEtzCredential: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/interbankpayment/api/Client/v1/AddEtzCredential', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateEtzCredential: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/interbankpayment/api/Client/v1/UpdateEtzCredential', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProvidusEasyPayCredential: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/interbankpayment/api/Client/v1/GetProvidusCredential')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  addProvidusCredential: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/interbankpayment/api/Client/v1/AddProvidusCredential', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateProvidusCredential: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/interbankpayment/api/Client/v1/UpdateProvidusCredential', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getInterBankTransferStatus: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/interbankpayment/api/Client/v1/')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createGatewayConfigurationAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CONFIGURE_TRANSFER_GL)
      const response = await axiosIns.post('/interbankpayment/api/Client/v1/AddTransferSettlementGl', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateGatewayConfigurationAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CONFIGURE_TRANSFER_GL)
      const response = await axiosIns.put('/interbankpayment/api/Client/v1/UpdateTransferSettlementGl', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  // FEE CONFIGURATION SETUP
  getFeeConfigurations: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/Client/v1/SearchTransferFeeConfig',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createFeeConfiguration: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CONFIGURE_TRANSFER_FEE)
      const response = await axiosIns.post('/interbankpayment/api/Client/v1/AddTransferFeeConfig', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateFeeConfiguration: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CONFIGURE_TRANSFER_FEE)
      const response = await axiosIns.put('/interbankpayment/api/Client/v1/UpdateTransferFeeConfig', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFeeConfigurationsByGateway: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CONFIGURE_TRANSFER_FEE)
      const response = await axiosIns.get(`/interbankpayment/api/Client/v1/SearchTransferFeeConfig?Gateway=${formData}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBankNameByAccountNumber: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/interbankpayment/api/OutwardTransferMiddleware/v1/NameEnquiry?DestinationAccountNumber=${formData.accountNumber}&SourceAccountNumber=${formData.sourceAccountNumber}&SourceAccountName=${formData.sourceAccountName}&ChannelCode=${formData.channelCode}&DestinationInstitutionCode=${formData.destinationInstitutionCode}&ClientRef=${formData.clientRef}&Amount=${formData.amount}`,
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  postOutwardTransferAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.INITIATE_TRANSFER)
      const response = await axiosIns.post(
        '/interbankpayment/api/OutwardTransferMiddleware/v1/OutwardTransfer',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFeeRangeAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.INITIATE_TRANSFER)
      const response = await axiosIns.get(
        `/interbankpayment/api/Client/v1/GetAmountFee?amount=${formData.amount}`,
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOutwardTransfer: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/OutwardTransferMiddleware/v1/SearchOutwardTransfer',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getInwardTransfers: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/OutwardTransferMiddleware/v1/SearchInwardTransfer',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadOutwardTransfers: async (context, { search, permission, fileExportFormat }) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/interbankpayment/api/OutwardTransferMiddleware/v1/ExportOutwardTransfers',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadInwardTransactionLogs: async (context, { search, permission, fileExportFormat }) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/interbankpayment/api/OutwardTransferMiddleware/v1/ExportInwardTransactionLogs',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url, { responseType: 'blob' })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  performPendingRequestAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(
        `/interbankpayment/api/OutwardTransferMiddleware/v1/PostPendingInwardRequest?ids=${formData.ids}&isSessionIDPassed=${formData.isSessionIDPassed}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  performRequeryStatus: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.INITIATE_TRANSFER)
      const response = await axiosIns.get(
        `/interbankpayment/api/OutwardTransferMiddleware/v1/TSQ?transactionReference=${formData.transactionReference}`,
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  performRetryTransfer: async (context, id) => {
    try {
      useJwt.setPermission(eChannelsPermission.RETRY_TRANSFER)
      const response = await axiosIns.post('/interbankpayment/api/OutwardTransferMiddleware/v1/RetryFailedTransfer', id)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAllBankList: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/interbankpayment/api/OutwardTransferMiddleware/v1/GetBanks')
      context.commit('setAllBankList', response.data.data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCurrentIntitutionGateway: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.SWITCH_TRANSFER_GATEWAY)
      const response = await axiosIns.get('/interbankpayment/api/Client/v1/GetCurrentGateway', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateIntitutionGateway: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/interbankpayment/api/Client/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getCustomerProfileList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/ibanking/api/Admin/v1/CustomerProfile/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCorporateCustomerProfileList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/ibanking/api/Admin/v1/CustomerProfile/CorporateSearch',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCustomerProfileAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/CustomerProfile/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountsByCustomerId: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.VIEW_INTERNET_BANKING_USERS)
      const response = await axiosIns.get(
        `/accounting/api/CustomerAccount/v1/GetAccountsByCustomerID?customerId=${formData.customerId}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCustomerProfileStatus: async (context, { statusValues, routeName, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/ibanking/api/Admin/v1/CustomerProfile/${routeName}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  generateTransactionReceipt: async (context, { transactionID, responseType }) => {
    try {
      useJwt.setPermission('VIEW_TRANSFER_REPORT')
      const response = await axiosIns.get(
        `/interbankpayment/api/OutwardTransferMiddleware/v1/GenerateReceiptViaReportsMS?transactionID=${transactionID}`,
        { responseType },
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadTransactionReceipt: async (context, { paymentReference, responseType, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/reporting/api/TransactionReports/v1/GetBillsReceipt?paymentReference=${paymentReference}`,
        { responseType },
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadElectricityReceipt: async (context, { transactionID, responseType, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/bills/api/BillsManagement/v1/GenerateReceipt?transactionID=${transactionID}`,
        { responseType },
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFDProfileList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/ibanking/api/Admin/v1/FixedDepositConfig/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProductProfileList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/ibanking/api/Admin/v1/CustomerOnboardingConfig/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createProductProfileAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CREATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG)
      const response = await axiosIns.post('/ibanking/api/Admin/v1/CustomerOnboardingConfig/Create', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateProductProfileAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.UPDATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/CustomerOnboardingConfig/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateProductProfileStatus: async (context, { statusValues, routeName, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/ibanking/api/Admin/v1/CustomerOnboardingConfig/${routeName}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createFixedDepositProfileAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CREATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG)
      const response = await axiosIns.post('/ibanking/api/Admin/v1/FixedDepositConfig/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateFixedDepositProfileAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.UPDATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/FixedDepositConfig/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateFixedDepositProfileStatus: async (context, { statusValues, routeName, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/ibanking/api/Admin/v1/FixedDepositConfig/${routeName}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getThemeConfigurationSetup: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/ibanking/api/Admin/v1/Theme/GetByRequestingBankCode')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getMandateBanks: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/interbankpayment/api/OutwardTransferMiddleware/v1/GetMandateBanks')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createThemeConfigurationSetupAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/ibanking/api/Admin/v1/Theme/Create', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateThemeConfigurationSetupAction: async (context, { formDataUpdate, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/Theme/Update', formDataUpdate)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountUpgradeRequest: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/ibanking/api/Admin/v1/GetAccountUpgradeRequests',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getAccountUpgradeByAccounNumber: async (context, { accountNumber, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/ibanking/api/Admin/v1/GetAccountUpgradeRequestByAccountNumber?accountNumber=${accountNumber}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  approveAccountUpgrade: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/ApproveAccountUpgradeRequest', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  declineAccountUpgrade: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/DeclineAccountUpgradeRequest', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  validateBVNAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/ibanking/api/Admin/v1/ValidateBVN', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  validateNINAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/ibanking/api/Admin/v1/ValidateNIN', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  validateTINAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/ibanking/api/Admin/v1/ValidateTIN', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFraudChecksList: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/ibanking/api/Admin/v1/InstitutionConfig/GetByRequestingBankCode')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateFraudCheckAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/InstitutionConfig/AddOrUpdate', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadBatchCard: async (context, { url, responseType }) => {
    try {
      const response = await axiosIns.get(url, { responseType })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBillTypeList: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/bills/api/BillsManagement/v1/GetAllBillers')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBillsCustomerNameAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/bills/api/BillsManagement/v1/GetCustomerInformation?CustomerId=${formData.customerId}&GlobalBillerIdentifier=${formData.globalBillerIdentifier}&ProductName=${formData.productName}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  performBillsPayment: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/bills/api/BillsManagement/v1/ProcessCustomerVendRequest', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  fetchBillsPaymentHistory: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/bills/api/BillsManagement/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  downloadBillsPaymentReport: async (context, { search, permission, fileExportFormat }) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/bills/api/BillsManagement/v1/ExportBillPaymentLogs',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  billsPaymentConfiguration: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/bills/api/BillsManagement/v1/CreateOrUpdateConfiguration', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBillPaymentConfiguration: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/bills/api/BillsManagement/v1/GetConfiguration')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBillsWalletBalance: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/bills/api/BillsManagement/v1/GetBalance')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountLimitDetails: async (context, { accountNumber, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/limits/api/CustomerAccountLimit/v1/GetAccountLimit?accountNumber=${accountNumber}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getInstitutionLimitDetails: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/limits/api/InstitutionLimit/v1/GetByBankCode')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createAccountLimit: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/limits/api/CustomerAccountLimit/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateAccountLimit: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/limits/api/CustomerAccountLimit/v1/AddOrUpdate', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCardLimitDetails: async (context, { cardId, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/limits/api/CustomerCardLimit/v1/GetByCardId?cardId=${cardId}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCardLimit: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/limits/api/CustomerCardLimit/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCardLimit: async (context, { formDataUpdate, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/limits/api/CustomerCardLimit/v1/Update', formDataUpdate)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createInstitutionLimit: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/limits/api/InstitutionLimit/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateInstitutionLimit: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/limits/api/InstitutionLimit/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getWebhookNotifications: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/comms/api/WebhookNotification/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getRetriggerWebhook: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/comms/api/WebhookNotification/v1/NotifyMissingInward', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  resendWebhookAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/comms/api/WebhookNotification/v1/Resend', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getRegulatoryLimitsList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/limits/api/RegulatoryLimit/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOpenAPIList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/admin/api/APIClient/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getNotificationPreference: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/admin/api/APIClient/v1/GetNotificationTypes')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createOpenAPIAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/admin/api/APIClient/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateOpenAPIAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/admin/api/APIClient/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateRegenerateClientSecret: async (context, { statusValues, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/admin/api/APIClient/v1/RegenerateSecret', statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateOpenAPIStatus: async (context, { statusValues, routeName, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/admin/api/${routeName}/v1/UpdateStatus`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCorporateAccountAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/ibanking/api/Account/v1/LinkCorporateProfileToCustomer', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  performCardPendingRequestAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/card/api/CardGeneration/v1/MarkCustomerCardReqStatusAsTreated', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProvidusCardAccountList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/tpcard/api/Report/v1/SearchCardRecord',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  generatePinAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/tpcard/api/ProvidusCards/v1/SetCardPIN', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createProvidusCardAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/tpcard/api/ProvidusCards/v1/LinkInstantCard', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCustomerInformationByAccountNumber: async (context, { permission, accountNumber }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/accounting/api/CustomerAccount/v1/GetAccountWithBasicCustomerInfoByAccountNumber?AccountNumber=${accountNumber}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCardTransactionReport: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/tpcard/api/Report/v1/SearchTransaction',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getIsoCardTransactionReport: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/TransactionReport/v1/SearchISOTransactionReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getRouteConfigList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/tpcard/api/RouteConfig/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateRouteConfigAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/tpcard/api/RouteConfig/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateKeyPair: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/tpcard/api/RouteConfig/v1/UpdateKeyPair', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateRouteConfigStatus: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/tpcard/api/RouteConfig/v1/UpdateStatus', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateMandateStatus: async (context, { formData }) => {
    try {
      useJwt.setPermission(eChannelsPermission.APPLY_EASYPAY_MANDATE)
      const response = await axiosIns.put('/interbankpayment/api/Client/v1/EasyPayProfileMandate/Activate', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getEasyPayProfile: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/Client/v1/SearchEasyPayProfile',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateEasyPayProfile: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/interbankpayment/api/Client/v1/UpdateEasyPayProfile', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createEasyPayProfile: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/interbankpayment/api/Client/v1/AddEazyPayProfile', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getInterbankProfile: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/Client/v1/GetCurrentBankDetails',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateInterbankProfile: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/interbankpayment/api/Client/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createInternetBankingEnrolUser: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(
        '/ibanking/api/Admin/v1/CustomerProfile/CreateProfileForExistingCustomer',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  resetFailedPasswordCount: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/CustomerProfile/ResetFailedPasswordCount', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  syncCustomerProfileFromCBA: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/CustomerProfile/SyncFromCBA', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  verifyBillsPaymentAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/bills/api/BillsManagement/v1/VerifyPayment', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  resendLoginToken: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)

      const response = await axiosIns.post('/ibanking/api/Admin/v1/CustomerProfile/ResendLoginToken', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGateways: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/Client/v1/GetPaymentGateways',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getNIPmodes: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/Client/v1/GetNipModes',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSavingsPocket: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/ibanking/api/Admin/v1/SavingsConfig/Search')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createSavingsPocketSetup: async (context, { payload, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/ibanking/api/Admin/v1/SavingsConfig/Add', payload)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateSavingsPocketSetup: async (context, { payload, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/SavingsConfig/Modify', payload)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateSavingsPocketSetupStatus: async (context, {
    statusValues, routeName, action, permission,
  }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/ibanking/api/Admin/v1/${routeName}/${action}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSavingsRateDetails: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/ibanking/api/Admin/v1/SavingsConfig/Search')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  addGatewaySettlementAccount: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)

      const response = await axiosIns.post('/interbankpayment/api/Client/v1/AddGatewaySettlementAccount', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateGatewaySettlementAccount: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)

      const response = await axiosIns.put('/interbankpayment/api/Client/v1/UpdateGatewaySettlementAccount', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGatewaySetlementAccounts: async (context, {
    search, page = 1, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/Client/v1/GetGatewaySetlementAccounts',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  updateGatewaySettlementAccountStatus: async (context, { statusValues, routeName, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(
        `/interbankpayment/api/${routeName}/v1/ActivateGatewaySettlementAccount`,
        null, // ← body is null (no request body)
        { params: { id: statusValues.id } },
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getUssdLimitDetails: async (context, { phoneNumber, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/limits/api/USSDLimit/v1/GetUSSDLimit?phoneNumber=${phoneNumber}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  addOrUpdate: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/limits/api/USSDLimit/v1/AddOrUpdate', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
